import { render } from "./MainCorporatePresentation.vue?vue&type=template&id=232a96ca&scoped=true"
const script = {}

import "./MainCorporatePresentation.vue?vue&type=style&index=0&id=232a96ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-232a96ca"]])

export default __exports__